import { render, staticRenderFns } from "./appButton.vue?vue&type=template&id=e23a66b2"
import script from "./appButton.vue?vue&type=script&lang=js"
export * from "./appButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports